import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace, getZIndex} from '../../common/utils';
import VueOverlay from '../overlay/index';
import Vue from 'vue';

var _createNamespace = createNamespace('popup'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Popup'),
    data: function data() {
        return {
            zIndex: getZIndex()
        };
    },
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        position: {
            type: String,
            default: 'center'
        },
        round: {
            type: Boolean,
            default: false
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: true
        },
        overlay: {
            type: Boolean,
            default: true
        },
        radius: {
            type: [Number, String],
            default: 0
        },
        container: {
            type: Function,
            default: function _default() {
                return document.body;
            }
        }
    },
    watch: {
        show: function show(val) {
            this.$overlay.show = !!val;
        }
    },
    created: function created() {
        var overlayConstructor = Vue.extend(VueOverlay);
        this.$overlay = new overlayConstructor({
            el: document.createElement('div'),
            propsData: {
                zIndex: this.zIndex - 1,
                container: this.container
            }
        });
        this.handleOverLay();
    },
    mounted: function mounted() {
        this.container().appendChild(this.$el);
    },
    methods: {
        getStyle: function getStyle() {
            var style = {
                zIndex: this.zIndex
            };

            if (this.radius) {
                if (this.position !== 'center') {
                    var PositionRadiusIndex = {
                        top: [2, 3],
                        right: [0, 3],
                        bottom: [0, 1],
                        left: [1, 2]
                    };
                    var radius = ['0', '0', '0', '0'];
                    radius[PositionRadiusIndex[this.position][0]] = ''.concat(this.radius, 'px');
                    radius[PositionRadiusIndex[this.position][1]] = ''.concat(this.radius, 'px');
                    style['borderRadius'] = radius.join(' ');
                } else {
                    style['borderRadius'] = ''.concat(this.radius, 'px');
                }
            }

            return style;
        },
        handleOverLay: function handleOverLay() {
            var _this = this;

            if (this.show) {
                this.$overlay.show = true;
            }

            if (!this.overlay) {
                this.$overlay.transparent = true;
            }

            this.$overlay.$on('overlay-click', function() {
                if (_this.closeOnClickOverlay) {
                    _this.$overlay.show = false;

                    _this.$emit('change', false);
                }

                _this.onClickOverlay();
            });
        },
        removeOverlay: function removeOverlay() {
            this.$overlay.$destroy();
        },
        onClickOverlay: function onClickOverlay() {
            this.$emit('overlay-click');
        },
        handleClosed: function handleClosed() {
            this.$emit('closed');
        },
        handleShowed: function handleShowed() {
            this.$emit('showed');
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.removeOverlay();
    },
    render: function render() {
        var h = arguments[0];
        var classes = [];
        classes.push(this.position);
        this.round && classes.push('round');
        return h(
            'transition',
            {
                attrs: {
                    duration: '250',
                    name: 'mai-popup-'.concat(this.position)
                },
                on: {
                    'after-enter': this.handleShowed,
                    'after-leave': this.handleClosed
                }
            },
            [
                h(
                    'div',
                    {
                        class: b(classes),
                        style: this.getStyle(),
                        directives: [
                            {
                                name: 'show',
                                value: this.show
                            }
                        ]
                    },
                    [this.$slots.default]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
